// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "-" + {"185":"9899ada07d1a7594e533","489":"bb1cdddaae7467526c35","542":"fb37c9a89d13ac75e215"}[chunkId] + ".js";
};